import {useCallback} from "react";
import {VerificationStepType} from "../../domain/verification/VerificationStepType";
import {VerifyService} from "../../service/VerifyService";
import {RqManuallySkipStep} from "../../api/dto/RqManuallySkipStep";

export const ManuallySkipStepViewModel = () => {

    const manuallySkipStep = useCallback(async (step: VerificationStepType, verificationId: string)=> {
        const currentStep = await VerifyService.getInstance().getCurrentStep(verificationId)
        localStorage.setItem("next-step", currentStep.token)
        await VerifyService.getInstance().manuallySkipStep(new RqManuallySkipStep(step.toUpperCase()), verificationId)
    }, [])

    return {
        manuallySkipStep
    }

}